import { createContext, useContext } from "react";

type PartnerAddDeviceOutletContext = {
  allowedMaxStep: number;
  setAllowedMaxStep: (step: number) => void;
};

export const PartnerAddDeviceContext =
  createContext<PartnerAddDeviceOutletContext | null>(null);

export const usePartnerAddDeviceContext = () => {
  const context = useContext(PartnerAddDeviceContext);

  if (!context) {
    throw new Error(
      "usePartnerAddDeviceContext must be used within Partner Add Device flow",
    );
  }

  return context;
};
